export function validateArguments(uri: string, threshold?: number) {
  validateUri(uri);
  if (threshold) {
    validateThreshold(threshold);
  }
}

export function validateUri(uri: string): void {
  if (!(typeof uri === "string")) {
    throw new TypeError('The "uri" argument must be a string');
  }
}

export function validateThreshold(value: number): void {
  if (!(typeof value === "number" && value >= 0 && value <= 1)) {
    throw new TypeError(
      'The "threshold" argument must be a number between 0.0 and 1.0'
    );
  }
}
